import { ToastOptions, toast } from 'react-toastify';
import actions from '../store/actions';
import store from '../store/store';
import identityStorage from '../infrastructure/authorization/identityStorage';
import SessionExpireState from './Common/SessionExpire/SessionExpireState';
import messageHelper from './Common/Message/MessageHelper';
import React from 'react';

const setupKeyDown = (): (() => void) => {

    const event = 'keydown';
    const handler = (e: KeyboardEvent): void => {

        if (e.key === 'Escape') {

            store.dispatch({ type: actions.common.closeModal, payload: null as any });
        }
    };

    window.addEventListener(event, handler);

    return () => {
        window.removeEventListener(event, handler);
    };
};

const getContent = (message: string): JSX.Element => {
    return <div>
        <p>{message}</p>
        <button type='button' className='bg-white btn cn-btn' onClick={() => identityStorage.increaseSessionExpireTime()}>Yes</button>
    </div>
};

const showMesage = (message: string): void => {

    var content = getContent(message);

    messageHelper.showMesageAsContent(content, true);
}

const sessionExpireCheck = () => {

    const oneMinuteInMileseconds = 60000;
    const minutesRequired = 5;
    const minutesRequiredForWarningDisplay = minutesRequired * oneMinuteInMileseconds;

    const onCheckIfExpireInFiveMinutes = () => {

        let identity = identityStorage.get();

        const minutesUntilSessionExpire = new Date(identity.expirationTimestampIso).getTime() - new Date(new Date().toISOString()).getTime();

        if (minutesUntilSessionExpire <= minutesRequiredForWarningDisplay) {

            const timeLeft = Math.round(minutesUntilSessionExpire / oneMinuteInMileseconds);

            let message = `${timeLeft < 0 ? `Your session has expired.` : `Please save your changes. Your session will expire in ${timeLeft} minutes. Click Ok button to increase your session time.`}`;

            showMesage(message);

            store.dispatch({ type: actions.sessionExpire.warningShowned, payload: { warningShowned: true } as SessionExpireState });

            const intervalId = store.getState().sessionExpireState.intervalId;

            window.clearInterval(intervalId);
        }
    }

    const state = store.getState();

    if (!state.sessionExpireState.intervalId && !state.sessionExpireState.warningShowned) {

        const intervalId = setInterval(onCheckIfExpireInFiveMinutes, oneMinuteInMileseconds);

        store.dispatch({ type: actions.sessionExpire.intervalId, payload: { intervalId } });
    }
}

export { setupKeyDown, sessionExpireCheck, showMesage };